const Currency = ({ ...props }) => {
    return (
        <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                id="Symbols"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="d/header.utility"
                    transform="translate(-47.000000, 0.000000)"
                    fill="currentColor"
                >
                    <g id="Group-3" transform="translate(48.000000, 1.000000)">
                        <polygon
                            id="carat-yellow-small"
                            points="14 7 19.0195313 7 16.5097656 9.86830357"
                        />
                        <g
                            id="noun_dollar-sign_71274"
                            fillRule="nonzero"
                            stroke="currentColor"
                            strokeWidth="0.2"
                        >
                            <path
                                d="M8.11936458,11.8396146 C8.11936458,9.709125 6.84383333,9.07994792 4.91486458,8.12741667 L3.85448958,7.60183333 C1.94057292,6.65833333 1.44048958,6.36225 1.44048958,5.16020833 C1.44048958,3.61391667 2.79978125,3.06283333 4.07123958,3.06283333 C4.67686458,3.06283333 6.65523958,3.21370833 6.65523958,5.16020833 C6.65523958,5.55191667 6.97345833,5.86854167 7.36357292,5.86854167 C7.75545833,5.86854167 8.07190625,5.55191667 8.07190625,5.16020833 C8.07190625,3.385125 6.91679167,2.11295833 5.11815625,1.75666667 L5.11815625,0.708333333 C5.11815625,0.317333333 4.80153125,0 4.40982292,0 C4.01882292,0 3.70148958,0.317333333 3.70148958,0.708333333 L3.70148958,1.67379167 C1.49166667,1.81333333 0.024,3.16979167 0.024,5.16020833 C0.024,7.29229167 1.29829167,7.92058333 3.22708333,8.87240625 L4.28763542,9.39816667 C6.20226042,10.3430833 6.702875,10.6391667 6.702875,11.8396146 C6.702875,13.7643333 4.68855208,13.9137917 4.07159375,13.9137917 C3.45463542,13.9137917 1.44084375,13.7643333 1.44084375,11.8396146 C1.44084375,11.4487917 1.12351042,11.1312813 0.732510417,11.1312813 C0.341510417,11.1312813 0.0241770833,11.4487917 0.0241770833,11.8396146 C0.0241770833,13.8172813 1.49255208,15.1638229 3.70255208,15.3028333 L3.70255208,16.2916667 C3.70255208,16.6826667 4.01988542,17 4.41088542,17 C4.80188542,17 5.11921875,16.6826667 5.11921875,16.2916667 L5.11921875,15.2227917 C6.94654167,14.8735833 8.11936458,13.6077917 8.11936458,11.8396146 L8.11936458,11.8396146 Z"
                                id="Path"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Currency
